import React from "react";
import { NavLink } from "react-router-dom";

function NavigationHeader({ title = "", classes = "" }) {
  return <div className={`navigation-title ${classes}`}>{title}</div>;
}

export { NavigationHeader };
